!function() {
    "use strict";
    var e = Promise, t = function(e, t) {
        var n = function(e) {
            for(var t = 0, n = e.length; t < n; t++)r(e[t]);
        }, r = function(param) {
            var e = param.target, t = param.attributeName, n = param.oldValue;
            e.attributeChangedCallback(t, n, e.getAttribute(t));
        };
        return function(o, l) {
            var _o_constructor = o.constructor, s = _o_constructor.observedAttributes;
            return s && e(l).then(function() {
                new t(n).observe(o, {
                    attributes: !0,
                    attributeOldValue: !0,
                    attributeFilter: s
                });
                for(var _$e = 0, _$t = s.length; _$e < _$t; _$e++)o.hasAttribute(s[_$e]) && r({
                    target: o,
                    attributeName: s[_$e],
                    oldValue: null
                });
            }), o;
        };
    };
    var n = !0, r = !1, o = "querySelectorAll";
    function l(e) {
        this.observe(e, {
            subtree: n,
            childList: n
        });
    }
    var s = "querySelectorAll", c = self.document, a = self.Element, i = self.MutationObserver, u = self.Set, f = self.WeakMap, h = function(e) {
        return s in e;
    }, _ref = [], d = _ref.filter;
    var g = function(e) {
        var t = new f, g = function(n, r) {
            var o;
            if (r) for(var l, s = function(e) {
                return e.matches || e.webkitMatchesSelector || e.msMatchesSelector;
            }(n), c = 0, a = w.length; c < a; c++)s.call(n, l = w[c]) && (t.has(n) || t.set(n, new u), o = t.get(n), o.has(l) || (o.add(l), e.handle(n, r, l)));
            else t.has(n) && (o = t.get(n), t.delete(n), o.forEach(function(t) {
                e.handle(n, r, t);
            }));
        }, p = function(e) {
            var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
            for(var n = 0, r = e.length; n < r; n++)g(e[n], t);
        }, w = e.query, y = e.root || c, m = function(e, t, s) {
            var c = function(t, r, l, s, a) {
                for(var i = 0, u = t.length; i < u; i++){
                    var u1 = t[i];
                    (a || o in u1) && (s ? r.has(u1) || (r.add(u1), l.delete(u1), e(u1, s)) : l.has(u1) || (l.add(u1), r.delete(u1), e(u1, s)), a || c(u1[o]("*"), r, l, s, n));
                }
            }, a = new (s || MutationObserver)(function(e) {
                for(var _$t = new Set, o = new Set, _$l = 0, _$s = e.length; _$l < _$s; _$l++){
                    var _e_l = e[_$l], _$s1 = _e_l.addedNodes, a = _e_l.removedNodes;
                    c(a, _$t, o, r, r), c(_$s1, _$t, o, n, r);
                }
            });
            return a.add = l, a.add(t || document), a;
        }(g, y, i), _a_prototype = a.prototype, b = _a_prototype.attachShadow;
        return b && (a.prototype.attachShadow = function(e) {
            var t = b.call(this, e);
            return m.add(t), t;
        }), w.length && p(y[s](w)), {
            drop: function(e) {
                for(var n = 0, r = e.length; n < r; n++)t.delete(e[n]);
            },
            flush: function() {
                var _$e = m.takeRecords();
                for(var t = 0, n = _$e.length; t < n; t++)p(d.call(_$e[t].removedNodes, h), !1), p(d.call(_$e[t].addedNodes, h), !0);
            },
            observer: m,
            parse: p
        };
    };
    var p = self.document, w = self.Map, y = self.MutationObserver, m = self.Object, b = self.Set, E = self.WeakMap, v = self.Element, S = self.HTMLElement, M = self.Node, O = self.Error, N = self.TypeError, A = self.Reflect, q = self.Promise || e, C = m.defineProperty, T = m.keys, D = m.getOwnPropertyNames, L = m.setPrototypeOf;
    var P = !self.customElements;
    var k = function(e) {
        var t = T(e), n = [], r = t.length;
        for(var o = 0; o < r; o++)n[o] = e[t[o]], delete e[t[o]];
        return function() {
            for(var o = 0; o < r; o++)e[t[o]] = n[o];
        };
    };
    if (P) {
        var $ = function $() {
            var _this = this, e = _this.constructor;
            if (!r1.has(e)) throw new N("Illegal constructor");
            var t = r1.get(e);
            if (u1) return h1(u1, t);
            var o = n1.call(p, t);
            return h1(L(o, e.prototype), t);
        };
        var n1 = p.createElement, r1 = new w, o1 = new w, l1 = new w, s1 = new w, c1 = [], a1 = function(e, t, n) {
            var r = l1.get(n);
            if (t && !r.isPrototypeOf(e)) {
                var _$t = k(e);
                u1 = L(e, r);
                try {
                    new r.constructor;
                } finally{
                    u1 = null, _$t();
                }
            }
            var o = (t ? "" : "dis") + "connectedCallback";
            o in r && e[o]();
        }, _g = g({
            query: c1,
            handle: a1
        }), i1 = _g.parse;
        var u1 = null;
        var f1 = function(t) {
            if (!o1.has(t)) {
                var n, r = new e(function(e) {
                    n = e;
                });
                o1.set(t, {
                    $: r,
                    _: n
                });
            }
            return o1.get(t).$;
        }, h1 = t(f1, y);
        C(self, "customElements", {
            configurable: !0,
            value: {
                define: function(e, t) {
                    if (s1.has(e)) throw new O(`the name "${e}" has already been used with this registry`);
                    r1.set(t, e), l1.set(e, t.prototype), s1.set(e, t), c1.push(e), f1(e).then(function() {
                        i1(p.querySelectorAll(e));
                    }), o1.get(e)._(t);
                },
                get: function(e) {
                    return s1.get(e);
                },
                whenDefined: f1
            }
        }), C($.prototype = S.prototype, "constructor", {
            value: $
        }), C(self, "HTMLElement", {
            configurable: !0,
            value: $
        }), C(p, "createElement", {
            configurable: !0,
            value (e, t) {
                var r = t && t.is, o = r ? s1.get(r) : s1.get(e);
                return o ? new o : n1.call(p, e);
            }
        }), "isConnected" in M.prototype || C(M.prototype, "isConnected", {
            configurable: !0,
            get () {
                return !(this.ownerDocument.compareDocumentPosition(this) & this.DOCUMENT_POSITION_DISCONNECTED);
            }
        });
    } else try {
        function I() {
            return self.Reflect.construct(HTMLLIElement, [], I);
        }
        I.prototype = HTMLLIElement.prototype;
        var e1 = "extends-li";
        self.customElements.define("extends-li", I, {
            extends: "li"
        }), P = p.createElement("li", {
            is: e1
        }).outerHTML.indexOf(e1) < 0;
        var _self_customElements = self.customElements, t1 = _self_customElements.get, n2 = _self_customElements.whenDefined;
        C(self.customElements, "whenDefined", {
            configurable: !0,
            value (e) {
                var _this = this;
                return n2.call(this, e).then(function(n) {
                    return n || t1.call(_this, e);
                });
            }
        });
    } catch (e) {
        P = !P;
    }
    if (P) {
        var H = function H(e) {
            var t = c2.get(e);
            T1(t.querySelectorAll(this), e.isConnected);
        };
        var e2 = self.customElements, _v_prototype = v.prototype, n3 = _v_prototype.attachShadow, r2 = p.createElement, o2 = e2.define, l2 = e2.get, _ref1 = A || {
            construct (e) {
                return e.call(this);
            }
        }, s2 = _ref1.construct, c2 = new E, a2 = new b, i2 = new w, u2 = new w, f2 = new w, h2 = new w, d1 = [], m1 = [], S1 = function(t) {
            return h2.get(t) || l2.call(e2, t);
        }, M1 = function(e, t, n) {
            var r = f2.get(n);
            if (t && !r.isPrototypeOf(e)) {
                var _$t = k(e);
                _ = L(e, r);
                try {
                    new r.constructor;
                } finally{
                    _ = null, _$t();
                }
            }
            var o = (t ? "" : "dis") + "connectedCallback";
            o in r && e[o]();
        }, _g1 = g({
            query: m1,
            handle: M1
        }), T1 = _g1.parse, _g2 = g({
            query: d1,
            handle (e, t) {
                c2.has(e) && (t ? a2.add(e) : a2.delete(e), m1.length && H.call(m1, e));
            }
        }), P1 = _g2.parse, $1 = function(e) {
            if (!u2.has(e)) {
                var t, n = new q(function(e) {
                    t = e;
                });
                u2.set(e, {
                    $: n,
                    _: t
                });
            }
            return u2.get(e).$;
        }, _$I = t($1, y);
        var _ = null;
        D(self).filter(function(e) {
            return /^HTML/.test(e);
        }).forEach(function(e) {
            var n = function n() {
                var _this = this, _$e = _this.constructor;
                if (!i2.has(_$e)) throw new N("Illegal constructor");
                var _i_get = i2.get(_$e), n = _i_get.is, o = _i_get.tag;
                if (n) {
                    if (_) return _$I(_, n);
                    var t1 = r2.call(p, o);
                    return t1.setAttribute("is", n), _$I(L(t1, _$e.prototype), n);
                }
                return s2.call(this, t, [], _$e);
            };
            var t = self[e];
            L(n, t), C(n.prototype = t.prototype, "constructor", {
                value: n
            }), C(self, e, {
                value: n
            });
        }), C(p, "createElement", {
            configurable: !0,
            value (e, t) {
                var n = t && t.is;
                if (n) {
                    var _$t = h2.get(n);
                    if (_$t && i2.get(_$t).tag === e) return new _$t;
                }
                var o = r2.call(p, e);
                return n && o.setAttribute("is", n), o;
            }
        }), n3 && (v.prototype.attachShadow = function(e) {
            var t = n3.call(this, e);
            return c2.set(this, t), t;
        }), C(e2, "get", {
            configurable: !0,
            value: S1
        }), C(e2, "whenDefined", {
            configurable: !0,
            value: $1
        }), C(e2, "define", {
            configurable: !0,
            value (t, n, r) {
                if (S1(t)) throw new O(`'${t}' has already been defined as a custom element`);
                var l;
                var s = r && r.extends;
                i2.set(n, s ? {
                    is: t,
                    tag: s
                } : {
                    is: "",
                    tag: t
                }), s ? (l = `${s}[is="${t}"]`, f2.set(l, n.prototype), h2.set(t, n), m1.push(l)) : (o2.apply(e2, arguments), d1.push(l = t)), $1(t).then(function() {
                    s ? (T1(p.querySelectorAll(l)), a2.forEach(H, [
                        l
                    ])) : P1(p.querySelectorAll(l));
                }), u2.get(t)._(n);
            }
        });
    }
}();

//# sourceMappingURL=app.4968af94.js.map
